<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Branches from "../components/Branches.svelte";
	import B2bApplicationForm from "../components/B2bApplicationForm.svelte";
	import type { B2bApplicationProps } from "./B2bApplicationProps.js";
	import Banner from "../components/Banner.svelte";
	import cake from "../../../core/assets/icons/cake.svg?raw";
	import cakesImgSm from "../assets/images/b2b-banner/cakes.jpeg?w=400&webp&imagetools";
	import cakesImgMd from "../assets/images/b2b-banner/cakes.jpeg?w=432&webp&imagetools";
	import cakesImgLg from "../assets/images/b2b-banner/cakes.jpeg?w=496&webp&imagetools";
	import Link from "../components/Link.svelte";
	import { b2bApplicationPathMap } from "../../../core/schema/paths/b2bApplicationPathMap";
	import { getGlobalSettings } from "../getGlobalSettings";

	type $$Props = B2bApplicationProps;
	const { plannedIceCreams } = $$restProps as $$Props;

	const { TENANT_LOCALE } = getGlobalSettings();

	const _ = $$restProps as $$Props;
	const anchor = "poptavka";
	const urlSlug = `/${b2bApplicationPathMap[TENANT_LOCALE]}#${anchor}`;
</script>

<Layout>
	<div class="container">
		<Banner
			headline="Spolupráce"
			subheadlineClasses="h2 mb-8 !text-lg lg:!text-xl xl:!text-2xl"
			subHeadline="Naše dorty do vašeho podniku"
			image={{
				alt: "Fotografie – ukázka náplně dortu",
				sizes: { sm: cakesImgSm, md: cakesImgMd, lg: cakesImgLg },
			}}
		>
			<p>
				{nbspify(
					"Provozujete kavárnu, hotel nebo restauraci a chcete svým hostům nabídnout dokonalé zákusky, na které se k vám budou pravidelně vracet?",
				)}
			</p>
			<br />
			<p><strong>{nbspify("Proč si vybrat nás?")}</strong></p>

			<ul class="list basis-[calc(50%-0.75rem)]">
				<li>{nbspify("všechny dobroty vyrábíme ručně a z kvalitních surovin")}</li>
				<li>{nbspify("máme bohaté portfolio dortů, které jen tak někde nenajdete")}</li>
				<li>{nbspify("objednávku dodáme až do vašeho podniku hned druhý den")}</li>
				<li>{nbspify("jednoduché objednání skrze B2B portál")}</li>
			</ul>

			<Link
				class="sm:!text-md mx-auto mt-10 !rounded-full !px-8 !py-2 sm:!px-12 sm:!py-4 lg:mx-0 xl:!px-14 xl:!py-[1.125rem] xl:!text-[1.375rem]"
				href={urlSlug}
				asButton
				variant="primary"
				icon={cake}
				iconClass="w-6"
			>
				Mám zájem o spolupráci
			</Link>
		</Banner>

		<section>
			<div class="w-100 mt-2 flex flex-col justify-evenly gap-5 sm:mt-16 sm:gap-0">
				<div class="text-center">
					<span class="decorative-headline block">{nbspify("Poptávka spolupráce")}</span>
					<h2 class="!mb-8 text-xl lg:text-2xl" id={anchor}>
						{nbspify("Vyplňte, prosím, tento jednoduchý formulář. Brzy se vám ozveme zpět!")}
					</h2>
				</div>

				<B2bApplicationForm />
			</div>
		</section>

		<section>
			<Branches isSmallMargin {plannedIceCreams} />
			<div class="mt-20 text-center text-xl font-semibold leading-[1] lg:text-2xl">
				<span>Těšíme se</span>
				<span class="block">na vaši návštěvu!</span>
			</div>
		</section>
	</div>
</Layout>
